<template>
  <div>
    <transition name="splash-fade">
      <div v-if="showSplash" class="splash-screen">
        <div class="splash-logo-container">
          <!-- Tilly Logo (Slide-in & subtle bounce) -->
          <img
            src="@/assets/logo/logo.svg"
            alt="Tilly Logo"
            class="splash-logo"
          />
          <!-- Sparkle (multi-point iconic flourish) -->
          <div class="sparkle-wrapper">
            <img
              src="@/assets/intro/yellow_stars.svg"
              alt="Sparkle1"
              class="splash-sparkle splash-sparkle-1"
            />
            <img
              src="@/assets/intro/yellow_stars.svg"
              alt="Sparkle2"
              class="splash-sparkle splash-sparkle-2"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SplashScreen',
  data() {
    return {
      showSplash: true,
    };
  },
  mounted() {
    // Brand-moment hold only — do NOT gate on `window.load`: on mobile it
    // waits for every <img> and font on the page, which can take several
    // seconds. The hero has its own cascade-in animations for unready
    // content.
    const isMobile =
      typeof window !== 'undefined' &&
      window.matchMedia('(max-width: 767px)').matches;
    const MIN_MS = isMobile ? 800 : 1200;
    setTimeout(() => {
      this.showSplash = false;
    }, MIN_MS);
  },
};
</script>

<style scoped>
#app {
  font-family: 'AirbnbCereal_W_Bk', -apple-system, BlinkMacSystemFont,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
  background: #fff;
}

.splash-screen {
  position: fixed;
  inset: 0;
  height: 100vh;
  min-height: -webkit-fill-available;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  z-index: 1000;
}

.main-content {
  /* Always render but initially invisible */
  position: relative;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.5s ease;
}

.main-content-visible {
  opacity: 1;
}

.splash-logo-container {
  position: relative;
  text-align: center;
}

/* Logo animation: slide-in & settle */
.splash-logo {
  width: 220px;
  max-width: 80vw;
  opacity: 0;
  transform: translateY(100%) scale(0.5);
  animation: logo-slide-settle 1.4s cubic-bezier(0.25, 0.1, 0.25, 1) both;
}

@keyframes logo-slide-settle {
  0% {
    opacity: 0;
    transform: translateY(100%) scale(0.5);
  }
  60% {
    opacity: 1;
    transform: translateY(-20px) scale(1.1);
  }
  80% {
    transform: translateY(8px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Sparkle wrapper to hold multiple points */
.sparkle-wrapper {
  position: absolute;
  top: -30px;
  left: 50%;
  width: 100px;
  height: 100px;
  transform: translateX(-50%);
  pointer-events: none;
}

/* Base sparkle style */
.splash-sparkle {
  position: absolute;
  opacity: 0;
  filter: drop-shadow(0 0 12px #c3e5ff) drop-shadow(0 0 16px #fff);
}

/* First sparkle: big burst */
.splash-sparkle-1 {
  top: 0;
  left: 50%;
  width: 40px;
  animation: sparkle-burst 1.2s ease-out 0.5s both;
}

/* Second sparkle: smaller shimmer */
.splash-sparkle-2 {
  top: 20px;
  left: 70%;
  width: 24px;
  animation: sparkle-shimmer 1s ease-out 0.8s both;
}

@keyframes sparkle-burst {
  0% {
    opacity: 0;
    transform: translate(-50%, 0) scale(0.2) rotate(-30deg);
  }
  30% {
    opacity: 1;
    transform: translate(-50%, -20px) scale(1.8) rotate(0deg);
  }
  60% {
    transform: translate(-50%, -10px) scale(1.4) rotate(15deg);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, 0) scale(0.8) rotate(30deg);
  }
}

@keyframes sparkle-shimmer {
  0% {
    opacity: 0;
    transform: translate(-50%, 0) scale(0.1) rotate(0deg);
  }
  50% {
    opacity: 0.8;
    transform: translate(-50%, -8px) scale(1) rotate(10deg);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, 0) scale(0.5) rotate(-10deg);
  }
}

/* Transitions */
.splash-fade-leave-active {
  transition: opacity 0.5s ease;
}
.splash-fade-leave-to {
  opacity: 0;
}

@media (max-width: 600px) {
  .splash-logo {
    width: 140px;
  }
  .sparkle-wrapper {
    width: 70px;
    height: 70px;
    top: -20px;
  }
  .splash-sparkle-1 {
    width: 28px;
  }
  .splash-sparkle-2 {
    width: 16px;
  }
}
</style>
